import { Estado } from "../interfaces/SuperAdmin/Others/iDataEstado";

// Función para extraer el número relevante del código
export const extractNumber = (codigo: string) => {
  const code = codigo.trim();
  let match = code.match(/(\d+)$/); // NOSONAR
  if (match) {
    return parseInt(match[1], 10);
  }
  match = code.match(/(\d+)/); // NOSONAR
  return match ? parseInt(match[1], 10) : 0;
};

interface Prop {
  estado?: string;
  estado_org?: string;
  [key: string]: any;
}

// Función para extraer qué estado tiene un array de objetos
export const getEstado = (
  object: Prop[],
  property: "estado" | "estado_org" = "estado"
): "success" | "warning" | "wrong" | "unknown" => {
  if (!object.length) return "wrong";

  if (object.some((s) => s[property] === Estado.ACTIVO)) {
    return "success";
  }

  if (object.some((s) => s[property] === Estado.INACTIVO)) {
    return "warning";
  }

  if (object.some((s) => s[property] === Estado.ELIMINADO)) {
    return "wrong";
  }

  return "unknown";
};
